import { useEffect, useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { Wordmark } from "./Wordmark";
import { NAV_LINKS } from "../lib/data";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled ? "bg-black/80 backdrop-blur-xl border-b border-[#D4AF37]/20 py-3" : "bg-transparent border-b border-transparent py-4 md:py-5"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 flex items-center justify-between gap-4">
        <button data-testid="nav-logo" onClick={() => go("#top")} aria-label="Good Shot Espresso home">
          <Wordmark good="text-lg md:text-2xl" esp="text-[0.48rem]" />
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              onClick={() => go(l.href)}
              className="text-[13px] uppercase tracking-[0.18em] text-white/70 hover:text-[#D4AF37] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta-inquire"
            onClick={() => go("#inquiry")}
            className="hidden sm:inline-flex items-center gap-2 border border-[#D4AF37] text-[#D4AF37] uppercase tracking-[0.14em] text-[10px] md:text-[11px] font-bold px-4 md:px-5 py-3 hover:bg-[#D4AF37] hover:text-black transition-colors duration-300 whitespace-nowrap"
          >
            Bring Good Shot To Your Event
            <ArrowRight className="w-3.5 h-3.5" />
          </button>
          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden text-white p-2 -mr-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-[#D4AF37]/20">
          <div className="px-5 py-6 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`mobile-link-${l.href.replace("#", "")}`}
                onClick={() => go(l.href)}
                className="text-left py-3 text-sm uppercase tracking-[0.18em] text-white/80 hover:text-[#D4AF37] border-b border-white/5 transition-colors"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="mobile-cta-inquire"
              onClick={() => go("#inquiry")}
              className="mt-4 inline-flex items-center justify-center gap-2 border border-[#D4AF37] text-[#D4AF37] uppercase tracking-[0.16em] text-xs font-bold px-6 py-4 hover:bg-[#D4AF37] hover:text-black transition-colors"
            >
              Bring Good Shot To Your Event <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
